"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MetaText = styled_components_1.default.span `
  font-style: italic;
  font-size: 12px;
`;
//# sourceMappingURL=meta-text.js.map